import fetchSync from 'sync-fetch';

export interface EnvConfig {
  Environment: string;
  InfoVersion: string;
  InfoAuthors: string;
  InfoCompany: string;
  InfoCopyright: string;
  BackendApiUrl: string;
  WebMetadataKeywords: string;
  WebMetadataRobots: string;
  GA_TrackingID: string;
}

let envConfig: EnvConfig;

function loadEnvConfig(): EnvConfig {
  // 127.0.0.0/8 are considered localhost for IPv4, [::1] is the IPv6 localhost address.
  const isLocalhost = globalThis.location.hostname === 'localhost'
    || globalThis.location.hostname === '[::1]'
    || /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/.test(globalThis.location.hostname);

  if (isLocalhost) {
    console.debug(`[envConfig] Loading from '.env'. Env: '${process.env.NODE_ENV}'.`);
    envConfig = {
      Environment: `${process.env.REACT_APP_ENVIRONMENT}`,
      InfoVersion: `${process.env.REACT_APP_INFO_VERSION}`,
      InfoAuthors: `${process.env.REACT_APP_INFO_AUTHORS}`,
      InfoCompany: `${process.env.REACT_APP_INFO_COMPANY}`,
      InfoCopyright: `${process.env.REACT_APP_INFO_COPYRIGHT}`,
      BackendApiUrl: `${process.env.REACT_APP_BACKEND_API_URL}`,
      WebMetadataKeywords: `${process.env.REACT_APP_WEB_METADATA_KEYWORDS}`,
      WebMetadataRobots: `${process.env.REACT_APP_WEB_METADATA_ROBOTS}`,
      GA_TrackingID: `${process.env.REACT_APP_GA_TRACKINGID}`
    };
  }
  else {
    try {
      console.debug(`[envConfig] Fetching from '/envConfig.json'. Env: '${process.env.NODE_ENV}'.`);
      const response = fetchSync('/envConfig.json');
      if (response.ok) {
        envConfig = response.json();
      }
      else {
        console.error(`[envConfig] Error loading: HTTP Status: ${response.status} - ${response.statusText}`);
      }
    }
    catch (error) {
      console.error('[envConfig] Error loading!', error);
    }
  }

  console.debug('[envConfig] Returning new copy.');
  console.debug(envConfig);
  return envConfig;
}

export function getEnvConfig(): EnvConfig {
  console.debug('[envConfig] Requested.');
  if (envConfig) {
    console.debug('[envConfig] Returning cached copy.');
    return envConfig;
  }

  return loadEnvConfig();
}
